/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import Vue from "vue";
import baseURL from "@/api/http-common";

let userObj =
  localStorage.getItem("telasUserObj") !== null &&
  localStorage.getItem("telasUserObj").length > 0
    ? JSON.parse(localStorage.getItem("telasUserObj"))
    : "";
const courseState = {
  courses: {},
  courseDetails: {},
  reviewerAssigned: false,
};
const getters = {
  isTestCourse: (state) =>
    state.courseDetails.post_meta !== undefined &&
    state.courseDetails.post_meta.forTest !== undefined &&
    state.courseDetails.post_meta.forTest[0] === "yes",
  interimReviewerObj: (state) =>
    state.courseDetails.assesment_data !== undefined &&
    state.courseDetails.assesment_data.interim_reviewer_data !== undefined &&
    state.courseDetails.assesment_data.interim_reviewer_data
      .assigned_interim_reviews_obj
      ? state.courseDetails.assesment_data.interim_reviewer_data
          .assigned_interim_reviews_obj
      : false,
  reviewerAssigned: (state) => state.reviewerAssigned,
};
const actions = {
  async submitCourse({ commit, rootState }, data) {
    commit("LOADING", { rootState });
    try {
      userObj =
        rootState.user.userDetails.length > 0
          ? rootState.user.userDetails
          : userObj;

      const { userToken } = data;
      const options = {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };
      const response = await Vue.axios.post(
        `${baseURL}extended-telasweb/v1/submit-course`,
        data,
        options
      );
      const actualData = response.data;
      commit("COURSESUBMITTED", { actualData, rootState });
    } catch (error) {
      if (error.response.length) {
        const actualData = error.response.data;
        commit("HANDLEERROR", { actualData, rootState });
      }
    }
    commit("ENDLOADING", { rootState });
  },
  async getCourseById({ commit, rootState }, data) {
    commit("LOADING", { rootState });
    try {
      const { userToken } = data;
      // eslint-disable-next-line prefer-destructuring
      const response = await Vue.axios.get(
        `${baseURL}wp/v2/telas-courses/${data.courseId}`,
        {
          params: {},
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }
      );
      const actualData = response.data;
      commit("SETCOURSEDETAIL", { actualData });
    } catch (error) {
      if (error) {
        const actualData = error.response.data;
        const origin = "getCourses";
        // commit('HANDLEERROR', { actualData, rootState, origin });
      }
    }
    commit("ENDLOADING", { rootState });
  },
  async changePostStatus({ commit, rootState }, data) {
    commit("LOADING", { rootState });

    const { userToken } = data;
    try {
      const options = {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };
      const response = await Vue.axios.post(
        `${baseURL}wp/v2/telas-courses/${data.courseId}`,
        data,
        options
      );
      const actualData = response.data;
      commit("SETCOURSEDETAIL", { actualData });
    } catch (error) {
      if (error) {
        const actualData = error.response.data;
        const origin = "getCourses";
        commit("HANDLEERROR", { actualData, rootState, origin });
      }
    }
    commit("ENDLOADING", { rootState });
  },
  async getCourseFramework({ commit, rootState }, { courseId, userToken }) {
    commit("LOADING", { rootState });
    try {
      const response = await Vue.axios.get(
        `${baseURL}wp/v2/telas-courses/${courseId}`,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }
      );
      const courseDetails = response.data;
      const frameworkId = courseDetails.acf.framework; // Assuming the framework ID is directly accessible like this
      commit("SETCOURSEFRAMEWORK", { frameworkId }); // You need to create this mutation
      return frameworkId; // Optionally return frameworkId if needed
    } catch (error) {
      console.error("Failed to fetch course framework", error);
      // Handle error here, perhaps with a mutation like HANDLEERROR
      commit("HANDLEERROR", { error, rootState });
    } finally {
      commit("ENDLOADING", { rootState });
    }
  },
  async updateCourseFramework(
    { commit, rootState },
    { courseId, frameworkId, userToken }
  ) {
    commit("LOADING", { rootState });
    try {
      const data = {
        acf: {
          framework: frameworkId,
        },
      };
      const options = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      };
      const response = await Vue.axios.post(
        `${baseURL}wp/v2/telas-courses/${courseId}`,
        data,
        options
      );
      const actualData = response.data;
      commit("COURSEFRAMEWORKUPDATED", actualData); // You'll need to create this mutation
      console.log("Framework updated successfully");
    } catch (error) {
      console.error("Failed to update the course framework", error);
      // Handle error here, perhaps with a mutation like HANDLEERROR
    }
    commit("ENDLOADING", { rootState });
  },
  async createAssessment({ commit, rootState }, data) {
    commit("LOADING", { rootState });
    const { userToken } = data;
    try {
      const options = {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };
      const response = await Vue.axios.post(
        `${baseURL}extended-telasweb/v1/create-assessment`,
        data,
        options
      );
      const actualData = response.data;
      commit("ASSIGNEDASSEROR", { actualData, rootState, data });
    } catch (error) {
      if (error) {
        const actualData = error.response.data;
        const origin = "ASSIGNEDASSEROR";
        commit("HANDLEERROR", { actualData, rootState, origin });
      }
    }
    commit("ENDLOADING", { rootState });
  },
  async deleteCourse({ commit, rootState }, data) {
    commit("LOADING", { rootState });
    const { userToken } = data;
    try {
      const options = {
        headers: {
          authorization: `Bearer ${userToken}`,
        },
      };
      const response = await Vue.axios.delete(
        `${baseURL}wp/v2/telas-courses/${data.courseId}?force=true`,
        options
      );
      commit("DELETECOURSE", { response, rootState });
    } catch (error) {
      console.log(error);
      if (error) {
        const actualData = error.response.data;
        const origin = "getCourses";
        commit("HANDLEERROR", { actualData, rootState, origin });
      }
    }
    commit("ENDLOADING", { rootState });
  },
};
const mutations = {
  SETCOURSEFRAMEWORK(state, { frameworkId }) {
    // Update the state with the framework ID as needed. This is just an example:
    courseState.courseDetails.frameworkId = frameworkId;
  },

  COURSESUBMITTED(state, { actualData, rootState }) {
    if (actualData.status === 200) {
      courseState.courses = actualData;
      rootState.common.messages.errors = "";
    } else {
      localStorage.setItem("telasUserObj", "");
      courseState.courses = "";
      rootState.common.messages.errors = actualData;
    }
  },
  COURSEFRAMEWORKUPDATED(state, actualData) {
    // Update your state as needed. This is just an example
    courseState.courseDetails = actualData;
    console.log("Course details updated in state");
  },
  DELETECOURSE(state, { response, rootState }) {
    if (response.status === 200) {
      rootState.common.messages.success = "Deleted";
    }
  },
  // eslint-disable-next-line no-unused-vars
  HANDLEERROR(state, { actualData, rootState, origin }) {
    rootState.common.messages.errors =
      "Something went wrong. Please try again.";
  },
  SETCOURSEDETAIL(state, { actualData }) {
    courseState.courseDetails = actualData;
  },
  // eslint-disable-next-line no-unused-vars
  ASSIGNEDASSEROR(state, { actualData, rootState, data }) {
    rootState.courses.courseDetails = actualData;
    rootState.common.messages.success = `Successfully assigned ${data.reviewerLevel}.`;
    state.reviewerAssigned = true;
  },
  LOADING(state, { rootState }) {
    rootState.common.loading = true;
  },
  ENDLOADING(state, { rootState }) {
    rootState.common.loading = false;
  },
};

export default {
  namespaced: true,
  state: courseState,
  getters,
  actions,
  mutations,
};
